
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"81","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.456 48.22l-15.685 2.823 2.614-15.895 29.96-29.854a5.227 5.227 0 017.424 0l5.542 5.542a5.23 5.23 0 010 7.424L39.456 48.22z","stroke":"#fff","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M62.984 50.834v15.685a5.229 5.229 0 01-5.228 5.228H8.086a5.229 5.229 0 01-5.229-5.228v-49.67a5.228 5.228 0 015.228-5.229h15.686","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    